<template>
    <div style="height: calc(100% - 60px);overflow: auto;">
        <div class="flex" style="font-size:10px">
            <div style="width:20%">
                <div style="color:grey">项目名称</div>
                <div>{{scrapDetail.data.project_name}}</div>

            </div>
            <div style="width:20%"> 
                <div style="color:grey">申请日期</div>
                <div>{{ scrapDetail.create_time }}</div>
            </div>
            <div style="width:20%">
                <div style="color:grey">报废说明</div>
                <div>{{ scrapDetail.data.note }}</div>
            </div>
        </div>
        <a-button v-if="approvalForm.id == scrapDetail.uid && scrapDetail.status == 0" size="small" type="danger" style="position: absolute;right: 5%;top: 3%;z-index: 100;" @click="edit">编辑</a-button>

        <a-divider />

        <div class="flex">
            <a-tabs style="position: relative;width: calc(66.67% - 12px);">
                <a-tab-pane tab="详细资料" :key="1">
                    <div class="">
                        <div>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">项目名称</div>
                                    <div class="fs14">{{((scrapDetail.data.project_name != "")&&(scrapDetail.data.project_name != null))?scrapDetail.data.project_name:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">物资名称</div>
                                    <div class="fs14">{{((scrapDetail.data.material_name != "")&&(scrapDetail.data.material_name != null))?scrapDetail.data.material_name:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20" >
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">品牌</div>
                                    <div class="fs14">{{((scrapDetail.data.brand != "")&&(scrapDetail.data.brand != null))?scrapDetail.data.brand:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">规格</div>
                                    <div class="fs14">{{((scrapDetail.data.size != "")&&(scrapDetail.data.size != null))?((scrapDetail.data.size.length > 20)?scrapDetail.data.size.substring(0,20) + "......":scrapDetail.data.size):"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20" >
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">单位</div>
                                    <div class="fs14">{{((scrapDetail.data.unit != "")&&(scrapDetail.data.unit != null))?scrapDetail.data.unit:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">数量</div>
                                    <div class="fs14">{{((scrapDetail.data.count != "")&&(scrapDetail.data.count != null))?scrapDetail.data.count:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20" >
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">单价</div>
                                    <div class="fs14">{{((scrapDetail.data.unit_price != "")&&(scrapDetail.data.unit_price != null))?scrapDetail.data.unit_price:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">金额</div>
                                    <div class="fs14">{{((scrapDetail.data.total_price != "")&&(scrapDetail.data.total_price != null))?scrapDetail.data.total_price:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20" >
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">维修费用</div>
                                    <div class="fs14">{{((scrapDetail.data.repair_fee != "")&&(scrapDetail.data.repair_fee != null))?scrapDetail.data.repair_fee:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">报废原因</div>
                                    <div class="fs14">{{((scrapDetail.data.reason != "")&&(scrapDetail.data.reason != null))?scrapDetail.data.reason:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">备注</div>
                                    <div class="fs14">{{((scrapDetail.data.note != "")&&(scrapDetail.data.note != null))?scrapDetail.data.note:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">附件</div>
                                    <!-- <div v-if="((scrapDetail.data.attachment != null)&&(scrapDetail.data.attachment != ''))" class="picture-container">
                                        <div v-for="(item, index) in scrapDetail.data.attachment" :key="index" class="w100 mb15 mt10">
                                            <img style="width:100px;height: 100px;" :src="item.url" @click="downImg(item)">
                                        </div>
                                    </div> -->
                                    <div v-if="((scrapDetail.data.attachment != null)&&(scrapDetail.data.attachment != ''))" class="flex" style="flex-wrap: wrap;">
                                        <div v-for="(item, index) in scrapDetail.data.attachment" :key="index" class="mb5">
                                            <img class="mr10" style="width:100px;height: 100px;" :src="item.url" @click="downImg(item)">
                                        </div>
                                    </div> 
                                    <div class="fs14" v-else>--</div>
                                </a-col>
                            </a-row>
                        </div>
                        <a-divider />
                        
                        <div>
                            <div>系统信息</div>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">创建人</div>
                                    <div class="fs14">{{((scrapDetail.create_person != "")&&(scrapDetail.create_person != null))?scrapDetail.create_person:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div class="fs13" style="color:grey;font-weight: bolder;">创建时间</div>
                                    <div class="fs14">{{((scrapDetail.create_time != "")&&(scrapDetail.create_time != null))?scrapDetail.create_time.replace("T", " "):"--"}}</div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </a-tab-pane>
            </a-tabs>
            <CardApprovalDetail :stamp="scrapDetail" :approvalDetail="approvalDetail" :approvalForm="approvalForm" @update-param="updateParam"></CardApprovalDetail>
            
        </div>
    </div>
</template>
<script>
    import CardApprovalDetail from './CardApprovalDetail.vue';

	export default {
        props:{
            scrapDetail:{
                type: Object,
            },
            approvalDetail:{
                type: Array,
            },
            approvalForm:{
                type: Object,
            }

        },
		components: {
            CardApprovalDetail
        },
		data() {
			return {
                data:[],
                columns:[
                    {
                        title: '序号',
                        dataIndex: 'key',
                        key: 'key',
                        width:'5%',
                    },
                    {
                        title: '物资名称',
                        dataIndex: 'name',
                        key: 'name',
                        width:'15%',
                        scopedSlots: { customRender: 'name' },
                    },
                    {
                        title: '物资规格',
                        dataIndex: 'size',
                        key: 'size',
                        ellipsis: true,
                    },
                    {
                        title: '物资单位',
                        dataIndex: 'unit',
                        key: 'unit',
                        width:'10%',
                    },
                    {
                        title: '调运数量',
                        dataIndex: 'count',
                        key: 'count',
                        width:'10%',
                        scopedSlots: { customRender: 'count' },
                    },
                ],
                page:{
                    page:1, totoal:0
                },
			}
		},
        created(){
            
        },
        methods:{
            downImg(item){
                const link = document.createElement('a');
                link.href = item.url;
                link.download = item.name; // 设置下载的文件名，根据实际需要修改
                link.target = '_blank'; // 在新窗口打开下载链接
                link.click(); // 模拟点击触发下载
            },
            updateParam(newParam){
                this.$emit('update-param', newParam);
            },
            edit(){
                const newParam = {key:3, data:[]};
                this.$emit('update-param', newParam);
            },    
        }
	}

</script>

<style>
  
</style>
